import React, { Component } from 'react';
import { parseExcel } from 'store/reducers/user';
import styles from './UsersTable.module.css';
import Popover from 'components/UI/Popover/Popover';
import { Table, Tag, Input, Button, Icon, Affix } from 'antd';
import exportToExcel from 'components/Export/ExportToXLSX';

class UsersTable extends Component {
  state = {
    filterDropdownVisible: false,
    data: null,
    searchText: '',
    filtered: false,
  };

  renderLabel = row => {
    if (!row) return <Tag color="red">Unverified</Tag>;
    else return <Tag color="blue">Verified</Tag>;
  };

  renderUUID = row => {
    const length = 14;
    if (row.length < length) {
      return <span className={styles.Span}>{row}</span>;
    } else {
      return (
        <span className={styles.Span}>
          <Popover title="UUID" data={row} length={length} />
        </span>
      );
    }
  };

  renderPlatform = row => {
    if (row === 'ANDROID') return <Tag color="green">{row}</Tag>;
    else if (row === 'IOS') return <Tag color="geekblue">{row}</Tag>;
    else return <span style={{ color: 'lightgrey' }}>{row}</span>;
  };

  renderInfo = row => {
    if (row === 'unavailable' || (typeof row === 'object' && row.props.children.join('') === 'unavailable'))
      return <span style={{ color: 'lightgrey' }}>unavailable</span>;
    else return row;
  };

  renderPhone = row => {
    let searchText = this.state.searchText;
    const _regex = new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i');
    return (
      <span>
        {row.split(_regex).map(
          (text, i) =>
            text === searchText ? (
              // if match with input search text
              // return highlighted text else return standard
              <span key={i} style={{ color: '#f50' }}>
                {text}
              </span>
            ) : (
              text
            ) // eslint-disable-line
        )}
      </span>
    );
  };

  // renderActions = row => {
  //     const { is_verified } = row
  //     if (is_verified) return <Button size="small" onClick={() => this.onUnverify(row)}>Unverify</Button>
  // }

  onInputChange = e => {
    const value = e.target.value;
    this.setState(prev => ({ ...prev, searchText: value }));
  };

  updateFilterData = (searchText, incomingData) => {
    const regex = new RegExp(searchText, 'gi');
    this.setState(prev => ({
      ...prev,
      filterDropdownVisible: false,
      filtered: !!searchText,
      // set filtered data
      users: incomingData
        .map(record => {
          const match = record.phone_no.match(regex);
          if (!match) return null;
          return {
            ...record,
          };
        })
        .filter(record => !!record) /* filtered out all the null values from an invalid match */,
    }));
  };

  onTableChange = (pagination, filter, sorter, currentTable) => {
    this.setState({ users: currentTable.currentDataSource });
  };

  // onUnverify = data => {
  //     const { phone_no_id: id } = data
  //     const { searchText } = this.state
  //     // accessing span set from filter
  //     // when applying my filter method, it will generate a span
  //     // thus we need to access the data from the within the span
  //     // should re-write this tho..
  //     this.props.unVerifyUser(id)
  //         .then(resp => {
  //             this.updateFilterData(searchText, resp)
  //             message.success(`Phone number unverified.`)
  //         })
  // }

  onSearch = () => {
    const { searchText } = this.state;
    const { users } = this.props;
    this.updateFilterData(searchText, users);
  };

  columns = () => {
    return [
      {
        title: 'User type',
        dataIndex: 'type',
        key: 'type',
        sorter: (a, b) => a.type.length - b.type.length,
      },
      {
        title: 'Device',
        children: [
          {
            title: 'Platform',
            dataIndex: 'platform',
            key: 'platform',
            width: 100,
            render: row => this.renderPlatform(row),
            sorter: (a, b) => a.platform.length - b.platform.length,
          },
          {
            title: 'UUID',
            dataIndex: 'uuid',
            key: 'uuid',
            width: 180,
            render: row => this.renderUUID(row),
          },
        ],
      },
      {
        title: 'Contractor Info',
        children: [
          {
            title: 'Company',
            dataIndex: 'company',
            key: 'company',
            render: row => this.renderInfo(row),
            sorter: (a, b) => {
              return a.company.length - b.company.length;
            },
          },
          {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: row => this.renderInfo(row),
          },
          {
            title: 'Phone',
            dataIndex: 'phone_no',
            key: 'phone_no',
            width: 100,
            render: row => this.renderPhone(row),
            filterDropdown: (
              <div className={styles.FilterDropdown}>
                <Input
                  type="number"
                  ref={ele => (this.searchInput = ele)}
                  placeholder="Search Phone"
                  value={this.state.searchText}
                  onChange={this.onInputChange}
                  onPressEnter={this.onSearch}
                />
                <Button onClick={this.onSearch} type="primary">
                  Search
                </Button>
              </div>
            ),
            filterIcon: <Icon type="search" style={{ color: this.state.filtered ? '#108ee9' : '#aaa' }} />,
            filterDropdownVisible: this.state.filterDropdownVisible,
            onFilterDropdownVisibleChange: visible => {
              this.setState(
                {
                  filterDropdownVisible: visible,
                },
                () => this.searchInput && this.searchInput.focus(),
              );
            },
          },
        ],
      },
      {
        title: 'Status',
        dataIndex: 'is_verified',
        key: 'is_verified',
        width: 100,
        defaultSortOrder: 'ascend',
        sorter: (a, b) => {
          return b.is_verified - a.is_verified;
        },
        render: row => this.renderLabel(row),
      },
    ];
  };

  renderTable = () => {
    const { users, isLoading } = this.props;
    const dataUsers = !this.state.users ? users : this.state.users;
    const parseUsersToExcel = parseExcel(dataUsers);
    return (
      <div>
        <Affix style={{ marginBottom: '20px' }}>
          <Button type="primary" onClick={() => exportToExcel(parseUsersToExcel, 'users')}>
            Export Users Data
          </Button>
        </Affix>
        <Table
          loading={isLoading}
          className={styles.Table}
          bordered
          size="middle"
          columns={this.columns()}
          rowKey={(_r, index) => index}
          dataSource={dataUsers}
          onChange={(pagination, filter, sorter, currentTable) =>
            this.onTableChange(pagination, filter, sorter, currentTable)
          }
        />
      </div>
    );
  };

  render() {
    return this.renderTable();
  }
}

export default UsersTable;



// WEBPACK FOOTER //
// ./src/components/Users/UsersTable.js